const jQ = window.jQuery;

export default class DomElement {
    constructor(selector) {
        this.element = jQ(selector);
    }

    static exists(selector) {
        return jQ(selector).length > 0;
    }

    get el() {
        return this.element;
    }

    toArray(jquery = false) {
        if(jquery) {
            return this.element.toArray().map(element => jQ(element));
        }
        return this.element.toArray();
    }

    get(selector) {
        return new DomElement(this.element.find(selector));
    }

    each(callback) {
        this.element.each((index, element) => {
            callback(index, jQ(element));
        });
    }

    listen(event, callback, context) {
        this.element.on(event, event => {
            callback.call(context, jQ(event.currentTarget), event);
        });
    }

    addClass(className) {
        return this.element.addClass(className);
    }

    toggleClass(className) {
        return this.element.toggleClass(className);
    }

    removeClass(className) {
        return this.element.removeClass(className);
    }
}


// WEBPACK FOOTER //
// ./app/utils/DomElement.js